















import Vue from 'vue'
import ScheduleWxSubTplMsg from '@/rule/components/settings/create/ScheduleWxSubTplMsg.vue';
import { WxSubTpl } from '@/rule/models/ScheduleMsg';
import Actions from './Actions.vue'
import {TaskType} from '@/common/models/TaskType'
import commonClient from '@/common/apis'

export default Vue.extend({
  data() {
    const tplMsg: WxSubTpl | null = null
    return {
      editParams: false,
      hasError: true,
      tplMsg,
    }
  },
  props: {
    tpl: {
      type: Object as () => WxSubTpl,
      required: true,
    },
    expectCount: {
      type: Number,
    },
  },
  components: {
    ScheduleWxSubTplMsg,
    Actions,
  },
  methods: {
    startValidate() {
      const comp = this.$refs.tplEdit as any
      comp.confirmWxTplSettings()
    },
    confirmCreate(ctx: any) {
      const {data, isTiming, scheduleAt} = ctx
      commonClient.createTask({
        input: {
          WxSub: {
            tpl: this.tplMsg,
          },
        },
        expectCount: this.expectCount || 0,
        taskType: TaskType.WxSubTpl,
        isTiming: isTiming,
        creator: data.openid,
        creatorName: data.name,
        scheduleAt: isTiming ? scheduleAt.format('YYYY-MM-DD HH:mm:ss') : null,
      }).success(() => {
        this.$Message.success('创建成功');
        this.$router.push('/mass/records');
      });
    },
    confirmTplMsg(data: any) {
      this.tplMsg = data.tpl
      this.hasError = data.hasError
      if(!data.hasError) {
        const actionsRef = this.$refs.actions as any
        actionsRef.confirmMassSend()
      }
    },
  },
})
